import React from 'react';
import SupportChatbot from '@/components/support/SupportChatbot';
import { useChat } from '@/lib/ChatContext';

/**
 * Global chatbot instance mounted once in AppLayout. Driven by the ChatContext
 * open-state so the navbar Live Chat button can trigger it. The floating
 * launcher is hidden app-wide; only the navbar button opens the flyout.
 */
export default function GlobalChatbot() {
  const { settings, isOpen, close, available } = useChat();
  if (!available) return null;
  return <SupportChatbot settings={settings} open={isOpen} onClose={close} hideLauncher />;
}